import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { TokenGate, getPortalToken } from '@lipaflow/portal-core'
import { useQuery } from '@tanstack/react-query'
import { ErrorState } from '@lipaflow/ui'
import { ownerApi, OWNER_NEXT_KEY, remember } from './api'

/**
 * The owner portal needs a phone sign-in. A decision link opened signed out is remembered, so after
 * the code the owner lands on the decision (rule 9.6). The link itself never carries a sign-in.
 */
export default function OwnerGate({ children }: { children: ReactNode }) {
  const location = useLocation()
  remember(OWNER_NEXT_KEY, `${location.pathname}${location.search}`)
  if (!getPortalToken()) {
    return <Navigate to="/view" replace />
  }
  return <TokenGate><OwnerAccess>{children}</OwnerAccess></TokenGate>
}

function OwnerAccess({ children }: { children: ReactNode }) {
  const me = useQuery({ queryKey: ['owner-me'], queryFn: ownerApi.me, staleTime: 60_000 })
  if (me.isLoading) return <p role="status">Loading your account…</p>
  if (me.isError) return <ErrorState title="Unable to check your owner account" onRetry={() => { void me.refetch() }} />
  if (!me.data?.is_owner) return <Navigate to="/" replace />
  return <>{children}</>
}
